module.exports = __webpack_public_path__ + "img/Bild2.1e207797.jpg";